// extracted by mini-css-extract-plugin
module.exports = {"module":"ErrorPages_module__2udtl","debugInfo":"ErrorPages_debugInfo__3JyJK"};